import styled from 'styled-components'
import { GTR } from '@farewill/ui/tokens'

export const Swatch = styled.div<{ color: string }>`
  width: ${GTR.S};
  height: ${GTR.S};
  border-radius: 50%;
  background: ${({ color }) => color};
`
